import styled from "@emotion/styled";

import { fontFredoka, theme } from "shared/lib/styles";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";
import { Button } from "scmp-app/components/posties/button";

import Star from "./star.svg";

export const Container = styled.div`
  display: flex;
  justify-content: center;

  padding-block: 40px 0;
  padding-inline: 0;

  ${theme.breakpoints.up("desktop")} {
    padding-block: 64px 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  align-items: center;

  max-inline-size: 1214px;
  margin-inline: auto;

  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;

    column-gap: 48px;
  }
`;

export const StyledDesktopImage = styled.img`
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: flex;

    inline-size: 30vw;
    block-size: auto;
    max-inline-size: 436px;
    aspect-ratio: 0.8349;
  }
`;

export const StyledMobileImage = styled.img`
  display: flex;

  inline-size: 335px;

  ${theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const StyledStar = styled(Star)`
  inline-size: 72px;
  block-size: 79px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 89px;
    block-size: 98px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  ${StyledStar} {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    ${StyledStar} {
      inset-inline-start: -72px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    ${StyledStar} {
      inset-block-start: -20px;
      inset-inline-start: -60px;
    }
  }
`;

export const ContentAndButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    row-gap: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    row-gap: 80px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  padding-inline: 20px;

  ${theme.breakpoints.up("desktop")} {
    row-gap: 24px;

    padding-inline: 0;
  }
`;

export const Header = styled(Heading)`
  margin-inline: auto;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  max-inline-size: 380px;

  ${theme.breakpoints.up("desktop")} {
    row-gap: 24px;

    max-inline-size: 442px;
  }
`;

export const Description = styled.div`
  color: #333333;
  font-size: 16px;
  font-family: ${fontFredoka};
  line-height: 22px;

  ${theme.breakpoints.up("desktop")} {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const StyledButtonContainer = styled.div`
  z-index: 2;

  display: flex;
  justify-content: center;

  ${theme.breakpoints.up("desktop")} {
    justify-content: flex-start;

    padding-inline: 0;
  }
`;

export const StyledButton = styled(Button)`
  text-transform: uppercase;
`;
